export default "__VITE_ASSET__CQmO1nDD__"